import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
  type ReactNode,
} from 'react';

import { TooltipContentCard, TooltipRoot, TooltipTrigger } from '../../Tooltip';

interface FilterChipTooltipProps
  extends Omit<ComponentPropsWithoutRef<typeof TooltipTrigger>, 'asChild'> {
  tooltip?: ReactNode;
}

export const FilterChipTooltip = forwardRef<
  ElementRef<typeof TooltipTrigger>,
  FilterChipTooltipProps
>(({ children, tooltip, ...props }, ref) => {
  return (
    <TooltipRoot delayDuration={200}>
      <TooltipTrigger ref={ref} {...props}>
        {children}
      </TooltipTrigger>
      {tooltip && (
        <TooltipContentCard sideOffset={6} className="max-w-[350px] p-2">
          {tooltip}
        </TooltipContentCard>
      )}
    </TooltipRoot>
  );
});

FilterChipTooltip.displayName = 'FilterChipTooltip';
